import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/portfolio1.jpg'
import IMG2 from '../../assets/portfolio2.jpg'
import IMG3 from '../../assets/portfolio3.jpg'
import IMG4 from '../../assets/portfolio4.jpg'
import IMG5 from '../../assets/portfolio5.png'
import IMG6 from '../../assets/portfolio6.jpg'

const Portfolio = () => {
    return (
        <section id='portfolio'>
            <h5> My Recent Work </h5>
            <h2> Portfolio</h2>

            <div className="container portfolio__container">
                <article className='portfoilo__item'>
                    <div className="portfoilo__item-image">
                        <img src={IMG1} alt=""/>
                    </div>

                    <h3> This is a Portfolio item title </h3>
                    <div className='portfolio__item-cta'>
                    <a href="https://github.com" className='btn' target='_blank' >Github</a>
                    <a href="https://dribble.com/Alien_pixles" className='btn btn-primary' target='_blank'>Live Demo</a>
                    </div>
                 </article>

                                {/*=====  IMG 1 ======*/}
                               
                 <article className='portfoilo__item'>
                    <div className="portfoilo__item-image">
                        <img src={IMG1} alt=""/>
                    </div>

                    <h3> This is a Portfolio item title </h3>
                    <div className='portfolio__item-cta'>
                    <a href="https://github.com" className='btn' target='_blank' >Github</a>
                    <a href="https://dribble.com/Alien_pixles" className='btn btn-primary' target='_blank'>Live Demo</a>
                    </div>
                 </article>
                                {/*=====  IMG 2 ======*/}

                <article className='portfoilo__item'>
                    <div className="portfoilo__item-image">
                        <img src={IMG1} alt=""/>
                    </div>

                    <h3> This is a Portfolio item title </h3>
                    <div className='portfolio__item-cta'>
                    <a href="https://github.com" className='btn' target='_blank' >Github</a>
                    <a href="https://dribble.com/Alien_pixles" className='btn btn-primary' target='_blank'>Live Demo</a>
                    </div>
                 </article>

                                {/*=====  IMG 3 ======*/}


                <article className='portfoilo__item'>
                    <div className="portfoilo__item-image">
                        <img src={IMG1} alt=""/>
                    </div>

                    <h3> This is a Portfolio item title </h3>
                    <div className='portfolio__item-cta'>
                    <a href="https://github.com" className='btn' target='_blank' >Github</a>
                    <a href="https://dribble.com/Alien_pixles" className='btn btn-primary' target='_blank'>Live Demo</a>
                    </div>
                 </article>

                                {/*=====  IMG 4 ======*/}

                <article className='portfoilo__item'>
                    <div className="portfoilo__item-image">
                        <img src={IMG1} alt=""/>
                    </div>

                    <h3> This is a Portfolio item title </h3>
                    <div className='portfolio__item-cta'>
                    <a href="https://github.com" className='btn' target='_blank' >Github</a>
                    <a href="https://dribble.com/Alien_pixles" className='btn btn-primary' target='_blank'>Live Demo</a>
                    </div>
                 </article>

                                {/*=====  IMG 5 ======*/}


                <article className='portfoilo__item'>
                    <div className="portfoilo__item-image">
                        <img src={IMG1} alt=""/>
                    </div>

                    <h3> This is a Portfolio item title </h3>
                    <div className='portfolio__item-cta'>
                    <a href="https://github.com" className='btn' target='_blank' >Github</a>
                    <a href="https://dribble.com/Alien_pixles" className='btn btn-primary' target='_blank'>Live Demo</a>
                    </div>
                 </article>

                                {/*=====  IMG 6 ======*/}



            </div>
        
        
        
        </section>
    )
}

export default Portfolio